var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.preloader ? [_c('client-only', [_c('v-lottie', {
    attrs: {
      "position": "fixed"
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "display-flex flex-column justify-content-center align-items-center gap-20"
  }, [_c('div', {
    staticClass: "display-flex justify-content-center align-items-center"
  }, [_c('nuxt-img', {
    staticClass: "w-auto",
    attrs: {
      "src": "/assets/images/svg/ic_activation-code.svg",
      "alt": "Airalo",
      "height": `125px`,
      "width": `125px`,
      "loading": "lazy"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "display-flex justify-content-center"
  }, [_c('i18n', {
    staticClass: "typo-p color-text-secondary text-center mb-0",
    attrs: {
      "path": "scenes.otp.description",
      "tag": "p"
    },
    scopedSlots: _vm._u([{
      key: "email",
      fn: function () {
        return [_c('a', {
          staticClass: "color-text-primary",
          attrs: {
            "href": `mailto:${_vm.email}`,
            "target": "_blank",
            "rel": "noopener"
          }
        }, [_vm._v("\n            " + _vm._s(_vm.email) + "\n          ")])];
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _c('form', {
    staticClass: "w-100",
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "display-flex flex-column jusify-content-center align-items-center gap-35"
  }, [_c('div', {
    staticClass: "display-flex justify-content-center align-items-center gap-10",
    attrs: {
      "dir": _vm.$dir() === 'rtl' ? 'auto' : false
    }
  }, [_c('VieOtpInput', {
    ref: "otpInput",
    attrs: {
      "input-classes": "input general-otp-field",
      "separator": "",
      "input-type": "text",
      "num-inputs": 4,
      "should-auto-focus": true,
      "is-input-num": true
    },
    on: {
      "on-complete": _vm.handleOnComplete
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w-100 display-flex justify-content-center"
  }, [_c('button', {
    staticClass: "button button-secondary-outline small",
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.resendActivation.apply(null, arguments);
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('scenes.verify.activation.code-resend')) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "w-100 mt-5"
  }, [_c('button', {
    staticClass: "button button-secondary block btn-primary-hv",
    attrs: {
      "data-testid": "continue-button",
      "disabled": _vm.preloader
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.activateUser.apply(null, arguments);
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('global.continue')) + "\n          ")])])])])])], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }